module.exports = __webpack_public_path__ + "media/images/icon-current-location-3b967ef344fd9dbbcc195c0f5c2afea9.svg";